// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__h7tg-","errorLogs":"EditorFooter_errorLogs__3Y7Rq"};